import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2px;
`;

export const Item = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

export const Label = styled.span<{ isListScreen: boolean, noWrap?: boolean }>`
  font-size: 11px;
  color: ${({ isListScreen }) => (isListScreen ? '#868C98' : 'white')};
  min-width: 70px;
  text-align: center;
  white-space: ${({ noWrap }) => (noWrap ? 'nowrap' : 'normal')};
`;
export const IconWrapper = styled.div<{ removeMargin?: boolean }>`
  width: 21.08px;
  height: 20.69px;
  margin: ${({ removeMargin }) => (removeMargin ? '0px 0px 8px' : '8px 0px')};
  text-align: center;
`;

export const NoIcon = styled.span`
  color: #868C98;
  font-size: 14px;
`;

export const EmptyButton = styled.button`
  border: 0;
  margin: 0;
  padding: 0;
  background: transparent;
  cursor: pointer;
`;
